import React, { useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Tooltip, message, Button } from 'antd';
import { CopyOutlined, CheckOutlined } from '@ant-design/icons';
import { useIntl } from 'react-intl';
import Messages from 'i18n/messages/common';

const CopyButton = (props) => {
  const intl = useIntl();
  const { text, size = 'small', type = 'link' } = props;
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    setCopied(true);
    message.success(intl.formatMessage(Messages?.copyMsg));

    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  return (
    <CopyToClipboard text={text} onCopy={handleCopy}>
      <Tooltip
        placement='top'
        title={
          copied
            ? intl.formatMessage(Messages?.copiedMsg) || 'Copied!'
            : intl.formatMessage(Messages?.tooltipCopy)
        }
      >
        <Button
          icon={copied ? <CheckOutlined /> : <CopyOutlined />}
          type={type}
          size={size}
          style={copied ? { color: '#52c41a' } : undefined}
        />
      </Tooltip>
    </CopyToClipboard>
  );
};

export default CopyButton;
